// Mentions légales — obligatoires (article 6-III de la LCEN).
import LegalShell from '../../components/urself/LegalShell'
import { COMPANY } from '../../lib/legal'
import { useT } from '../../lib/i18n'

// Une valeur non renseignée s'affiche en rouge plutôt que de passer
// inaperçue : c'est ce qui évite de mettre en ligne un site incomplet.
const V = ({ v }) => String(v).includes('REMPLIR')
  ? <span className="u-todo">{v}</span>
  : <>{v}</>

export default function Mentions () {
  const L = useT().legal.mentions

  return (
    <LegalShell title={L.title} updated={L.updated} intro={L.intro}>
      <h2>{L.publisherT}</h2>
      <dl className="u-def">
        <div><dt>{L.name}</dt><dd><V v={COMPANY.legalName} /></dd></div>
        <div><dt>{L.form}</dt><dd><V v={COMPANY.legalForm} /></dd></div>
        <div><dt>{L.capital}</dt><dd><V v={COMPANY.capital} /></dd></div>
        <div><dt>{L.address}</dt><dd><V v={COMPANY.address} /></dd></div>
        <div><dt>{L.registration}</dt>
          <dd><V v={COMPANY.siren} /> — RCS <V v={COMPANY.rcs} /></dd></div>
        <div><dt>{L.vat}</dt><dd><V v={COMPANY.vat} /></dd></div>
        <div><dt>{L.director}</dt><dd><V v={COMPANY.director} /></dd></div>
        <div><dt>{L.contact}</dt>
          <dd><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></dd></div>
      </dl>

      <h2>{L.hostT}</h2>
      <dl className="u-def">
        <div><dt>{L.hostName}</dt><dd><V v={COMPANY.hostName} /></dd></div>
        <div><dt>{L.hostAddress}</dt><dd><V v={COMPANY.hostAddress} /></dd></div>
        <div><dt>{L.hostPhone}</dt><dd><V v={COMPANY.hostPhone} /></dd></div>
      </dl>

      <h2>{L.ipT}</h2>
      <p>{L.ipP}</p>

      <h2>{L.artT}</h2>
      <p>
        {L.artP1}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
        {L.artP2}
      </p>

      <h2>{L.reportT}</h2>
      <p>{L.reportP}</p>
    </LegalShell>
  )
}
